import {
  Card,
  Form,
  Input,
  Button,
  DatePicker,
  message,
  Divider,
  Dropdown,
  Modal,
  Space,
  Select,
} from "antd";
import React, { useEffect, useState, useRef,useWatch } from "react";
import dayjs from "dayjs";
import http from "@/utils/http";
import api from "@/utils/api";
import EnhancedTable from "@/hocComponents/EnhancedTable";
import {
  MenuOutlined,
  SwapOutlined,
  DownOutlined,
} from "@ant-design/icons";
import WireTransferModal from "./WireTransferModal";
import { bankRecDate as convertArrayToDayjs } from "@/views/BankReconciliation/BankRec/dates";
const RecordFundTransferPage = () => {
  const [form] = Form.useForm();
  const [tableList, setTableList] = useState([]);
  const [tableLoading, setTableLoading] = useState(false);
  const [filtersCollapsed, setFiltersCollapsed] = useState(false);
  const [entityList, setEntityList] = useState([]);
  const [bankNameList, setBankNameList] = useState([]);
  const [filters, setFilters] = useState({});
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 500,
    total: 0,
  });
  const [wireTransferVisible, setWireTransferVisible] = useState(false);
  const [wireTransferRecord, setWireTransferRecord] = useState(null);
  const loadedYearRef = useRef(null);
  const [selectLoading, setSelectLoading] = useState(false);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [batchClearing, setBatchClearing] = useState(false);
  const [pageType, setPageType] = useState(null);
  // select 数据获取
const buildSelectQuery = ({ year, glChartNameId, bankName, baiCode }) => {
  const body = {
    year,
    glChartNameId: glChartNameId ?? "",
  };
  if (bankName) body.bankName = bankName;
  if (baiCode) body.baiCodeFilter = baiCode; // 表单字段 baiCode -> 接口字段 baiCodeFilter
  return body;
};

// select 数据获取(POST)
const getSelectOptions = async (apiUrl, setter, body) => {
  try {
    const response = await http.post(apiUrl, body);
    if (response?.code === "1") {
      setter(
        (response.data || []).map((item) => ({
          value: item.value,
          label: item.label,
        })),
      );
    }
  } catch (error) {
    setter([]);
  }
};

const refreshSelectsIfNeeded = async (query, force = false) => {
  const body = buildSelectQuery(query);
  // 缓存 key 包含所有条件,bankName / baiCode 变了也会重新请求
  const cacheKey = JSON.stringify(body);
  if (!force && loadedYearRef.current === cacheKey) return;
  loadedYearRef.current = cacheKey;

  setSelectLoading(true);
  try {
    await Promise.all([getEntityList(body), getBankNameList(body)]);
  } finally {
    setSelectLoading(false);
  }
};
const getEntityList = (body) =>
  getSelectOptions(api.getBankRecByTrust, setEntityList, body);
const getBankNameList = (body) =>
  getSelectOptions(api.getBankRecByBankName, setBankNameList, body);
  // 处理菜单点击
  const handleMenuClick = async (e, record) => {
    if (e.key === "wireTransfer") {
      setWireTransferRecord(record);
      setWireTransferVisible(true);
    }
  };

  // 表格列定义
  const columns = [
    {
      title: "Action",
      dataIndex: "index",
      align: "center",
      width: 60,
      render: (text, record) => {
      const menuItems = [
          {
            key: "wireTransfer",
            icon: <SwapOutlined style={{ color: "#00c0ef", fontSize: 17 }} />,
            label: <div>Fund transfer</div>,
          },
        ].filter(Boolean);
        return menuItems.length > 0 ? (
          <Dropdown
            menu={{
              items: menuItems,
              onClick: (e) => handleMenuClick(e, record),
            }}
            trigger={["click"]}
          >
            <MenuOutlined
              style={{ cursor: "pointer", fontSize: 16, color: "#0e78a9" }}
            />
          </Dropdown>
        ) : null;
      },
    },
    {
      title: "Trans Type",
      dataIndex: "type",
      filterKey: "type",
      filterType: "select",
      selectOptions: [
        { value: "CP", label: "Bank - Debit" },
        { value: "CR", label: "Bank - Credit" },
      ],
      render: (text) => {
        const map = { CP: "Bank - Debit", CR: "Bank - Credit" };
        return map[text] || text;
      },
    },

    {
      title: "Amount",
      dataIndex: "amount",
      filterKey: "amount",
      key: "amount",
      width: 120,
      isBracketAmountFlag: true,
    },
    {
      title: "Check #",
      dataIndex: "checkNo",
      filterKey: "checkNo",
    },
    {
      title: "Date",
      dataIndex: "date",
      filterKey: "date",
      filterType: "date",
      render: (v) => {
        return convertArrayToDayjs(v)?.format("MM/DD/YYYY");
      },
    },
    {
      title: "Description",
      dataIndex: "remark",
      filterKey: "remark",
      width: 300,
      render: (text, record) => {
        if (record?.remark && record?.trustNameRemark) {
          return (
            <div style={{ display: "flex", flexDirection: "column" }}>
              <span>{record.remark}</span>
              <span>({record.trustNameRemark})</span>
            </div>
          );
        }
        return record?.remark || record?.trustNameRemark || "";
      },
    },
    {
      title: "BAI Code",
      dataIndex: "baiCode",
      filterKey: "baiCode",
      width: 120,
      render: (v, record) => v ?? record?.baiCode ?? "",
    },
    {
      title: "Bank Name",
      dataIndex: "bankName",
      filterKey: "bankName",
      filterType: "select",
      selectOptions: bankNameList,
      selectLoading,
    },
    {
      title: "Account #",
      dataIndex: "bankAccount",
      filterKey: "bankAccount",
    },
    {
      title: "PPM Bank #",
      dataIndex: "bank",
    },
    {
      title: "Account Remark",
      dataIndex: "bankRemark",
    },
    {
      title: "Entity",
      dataIndex: "trust",
      filterKey: "trust",
      width: 180,
      filterType: "select",
      selectOptions: entityList,
      selectLoading,
      render: (text, record) => {
        if (record?.trustName && record?.trust) {
          return (
            <div style={{ display: "flex", flexDirection: "column" }}>
              <span>{record.trustName}</span>
              <span>({record.trust})</span>
            </div>
          );
        }
        return record?.trust || record?.trustName || "";
      },
    },
  ];

  // 从 URL 参数读取数据，回填并自动查询
  useEffect(() => {
    const initPage = async () => {
      const hash = window.location.hash;
      const queryString = hash.includes("?") ? hash.split("?")[1] : "";
      const urlParams = new URLSearchParams(queryString);
      const bankName = urlParams.get("bankName");
      const baiCode = urlParams.get("baiCode");
      const yearParam = urlParams.get("year");
      // const type = urlParams.get("type");
      // setPageType(type);
      // URL 有 year 就使用 URL year，否则使用当前年份
      const currentYear = dayjs().year();
      let year = currentYear;
      if (yearParam) {
        const yearNum = parseInt(yearParam, 10);
        if (!isNaN(yearNum)) {
          year = yearNum;
        }
      }
      const yearDayjs = dayjs().year(year);
      // 回填表单
      form.setFieldsValue({
        bankName: bankName || "",
        baiCode: baiCode || "",
        year: yearDayjs,
      });

      // 初始化 Select
     refreshSelectsIfNeeded({ year, glChartNameId: "", bankName, baiCode }, true);
      // 初始化列表
      runQuery({
        bankName: bankName || "",
        baiCode: baiCode || "",
        year,
        page: pagination.current,
        count: pagination.pageSize,
      });
    };
    initPage();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const runQuery = async (params) => {
    setTableLoading(true);
    try {
      const requestData = {
        page: params.page ?? null,
        count: params.count ?? null,
      };

      Object.keys(params).forEach((key) => {
        if (key === "page" || key === "count") return;
        if (
          params[key] !== undefined &&
          params[key] !== null &&
          params[key] !== ""
        ) {
          if (key === "date" && params[key]) {
            const date = dayjs(params[key]);
            if (date.isValid()) {
              requestData[key] = date.format("YYYY-MM-DD");
            }
          } else {
            const targetKey = key === "baiCode" ? "baiCodeFilter" : key;
            requestData[targetKey] = params[key];
          }
        }
      });
      requestData.glChartNameId = params.glChartNameId ?? "";
      const res = await http.post(api.getRecordFundTransfer, requestData);
      if (res?.code !== "1") {
        message.error(res?.msg);
        return;
      }
      const rows = (res?.data?.list || res?.data?.rows || res?.data || []).map(
        (item, index) => ({
          ...item,
          key: item.bankTransNewId ?? index,
        }),
      );
      setTableList(rows);
      setSelectedRowKeys([]);
      setPagination((prev) => ({
        ...prev,
        current: res?.data?.pageNum ?? params.page ?? prev.current,
        pageSize: res?.data?.pageSize ?? params.count ?? prev.pageSize,
        total: res?.data?.total ?? rows.length,
      }));
    } catch (err) {
      message.error(err?.message);
    } finally {
      setTableLoading(false);
    }
  };
  const handleRecordTransferClick = () => {
    Modal.confirm({
      title: "Confirm",
      content: `Are you sure you want to clear ${selectedRowKeys.length} selected transaction(s)?`,
      centered: true,
      okText: "OK",
      cancelText: "Cancel",
      onOk: handleBatchClear,
    });
  };
  const handleBatchClear = async () => {
    if (selectedRowKeys.length === 0) return;

    setBatchClearing(true);
    try {
      const res = await http.get(api.getBatchFundTransfer, {
        params: {
          bankTransIds: selectedRowKeys.join(","),
        },
      });

      const isSuccess = res?.code === "1";

      if (isSuccess) {
        setSelectedRowKeys([]);
      }

      const showResult = isSuccess ? Modal.success : Modal.error;
      showResult({
        title: "Notice",
        content: res?.msg,
        centered: true,
        okText: "OK",
        onOk: () => {
          if (isSuccess) {
            handleTableChange(pagination);
          }
        },
      });
    } catch (err) {
      message.error(err?.message);
    } finally {
      setBatchClearing(false);
    }
  };
  const rowSelection = {
    selectedRowKeys,
    onChange: (keys) => setSelectedRowKeys(keys),
  };

  const handleSubmit = async (values) => {
    const year = values.year ? values.year.year() : dayjs().year();

    setFilters({});
    setPagination({ ...pagination, current: 1 });

    const params = {
      bankName: values.bankName || "",
      baiCode: values.baiCode || "",
      year,
      page: 1,
      count: pagination.pageSize,
    };

    const hash = window.location.hash;
    const path = hash.includes("?")
      ? hash.split("?")[0]
      : hash || "#/BankReconciliation/BankRec/component/FundTransferPage";

    const searchParams = new URLSearchParams();
    searchParams.set("bankName", params.bankName);
    searchParams.set("baiCode", params.baiCode);
    searchParams.set("year", year.toString());
    window.history.replaceState({}, "", `${path}?${searchParams.toString()}`);
    refreshSelectsIfNeeded({
  year,
  glChartNameId: "",
  bankName: values.bankName,
  baiCode: values.baiCode,
});
    runQuery(params);
  };
  const handleFilterSubmit = (nextFilters) => {
    setFilters(nextFilters);
    const values = form.getFieldsValue();
    const year = values.year ? values.year.year() : dayjs().year();
    const params = {
      bankName: values.bankName || "",
      baiCode: values.baiCode || "",
      year,
      page: 1,
      count: pagination.pageSize,
      ...nextFilters,
    };

    setPagination((prev) => ({
      ...prev,
      current: 1,
    }));

    runQuery(params);
  };
  const handleTableChange = (newPagination) => {
    setPagination(newPagination);
    const values = form.getFieldsValue();
    const params = {
      bankName: values.bankName || "",
      baiCode: values.baiCode || "",
      year: values.year ? values.year.year() : dayjs().year(),
      glChartNameId: values.glChartName,
      page: newPagination.current,
      count: newPagination.pageSize,
      ...filters,
    };

    runQuery(params);
  };

  return (
    <div className="fund-transfer-page">
      {/* 头部 */}
      <div className="fund-transfer-header">
        <div className="fund-transfer-header-title">
          <MenuOutlined />
          Record Fund Transfer
        </div>
      </div>

      <Divider
        style={{ borderColor: "#E2E8F0", marginTop: 8, marginBottom: 16 }}
      />
      <div
        className={`fund-transfer-layout ${filtersCollapsed ? "fund-transfer-layout-collapsed" : ""}`}
      >
        {!filtersCollapsed && (
          <Card className="fund-transfer-filter-card" bordered={false}>
            <div className="filter-card-header">
              <span className="filter-card-title">Filters</span>
              <button
                className="filter-hide-btn"
                onClick={() => setFiltersCollapsed(true)}
              >
                Hide
              </button>
            </div>

            <Form form={form} layout="vertical" onFinish={handleSubmit}>
              <Form.Item label="Bank Name" name="bankName">
                <Input placeholder="Bank Name" allowClear />
              </Form.Item>
              <Form.Item label="BAI Code" name="baiCode">
                <Input placeholder="e.g. 1000,1005-1010" allowClear />
              </Form.Item>
              <Form.Item label="Year" name="year">
                <DatePicker
                  picker="year"
                  style={{ width: "100%" }}
                  allowClear={false}
                />
              </Form.Item>
              <Form.Item style={{ marginBottom: 0, textAlign: "center" }}>
                <Button type="primary" htmlType="submit" loading={tableLoading}>
                  Submit
                </Button>
              </Form.Item>
            </Form>
          </Card>
        )}

        {/* 右侧表格区域 */}
        {filtersCollapsed && (
          <div className="result-show-filters-wrapper">
            <button
              className="result-show-btn"
              onClick={() => setFiltersCollapsed(false)}
            >
              <DownOutlined />
              Show filters
            </button>
          </div>
        )}

        <div className="fund-transfer-result-card">
          <div className="result-card-header">
            <span className="result-card-title">Record Fund Transfer List</span>
            <Space>
                <Button
                  type="primary"
                  disabled={selectedRowKeys.length === 0}
                  loading={batchClearing}
                  onClick={handleRecordTransferClick}
                >
                  Record Transfer
                  {selectedRowKeys.length > 0
                    ? ` ( ${selectedRowKeys.length} )`
                    : ""}
                </Button>
            </Space>
          </div>

          <div className="result-card-body">
            <div className="fund-transfer-table-wrapper">
              <EnhancedTable
                loading={tableLoading}
                dataSource={tableList}
                columns={columns}
                rowKey="key"
                size="small"
                rowSelection={rowSelection}
                pagination={{
                  current: pagination.current,
                  pageSize: pagination.pageSize,
                  total: pagination.total,
                  showSizeChanger: true,
                  showQuickJumper: true,
                  pageSizeOptions: ["25", "50", "100", "500"],
                  showTotal: (total) => `Total ${total} items`,
                }}
                filters={filters}
                onFilterChange={(key, value) => {
                  setFilters((prev) => ({
                    ...prev,
                    [key]: value,
                  }));
                }}
                onFilterSubmit={handleFilterSubmit}
                onChange={handleTableChange}
                scroll={{ x: "max-content", y: "calc(100vh - 300px)" }}
              />
            </div>
          </div>
        </div>
      </div>

      {/* Wire Transfer Modal */}
      <WireTransferModal
        visible={wireTransferVisible}
        record={wireTransferRecord}
        onClose={() => {
          setWireTransferVisible(false);
          setWireTransferRecord(null);
        }}
        onSuccess={() => {
          handleTableChange(pagination);
        }}
        apiType="recordFundTransfer"
      />
    </div>
  );
};

export default RecordFundTransferPage;
